<template>
  <div class="container main-area">
    <div class="row">
      <div class="col-md-12">
        <h1 class="centered">Продвинутый уровень</h1>
        <br>
        <h3>Программа курса</h3>
        <span>Курс состоит из двух модулей</span>
        <ul class="course-list list-group">
          <li class="list-group-item">
            <strong>1. «Приморское кольцо: Ораниенбаум – Кронштадт – Выборг» </strong> <br>
            (октябрь 2017 – январь 2018) <br>
          </li>
          <li class="list-group-item">
            <strong>2. Городские тематические экскурсии «Санкт-Петербург сквозь призму веков»</strong> <br>
            (февраль 2018 – апрель 2018)
          </li>
        </ul>
        <br>
        <div class="enroll-btn">
          <router-link class="btn btn-success btn-md btn-block" :to="{name: 'OnlineEnrollment'}">Записаться</router-link>
        </div>
        <br>
        <h3>Продолжительность курса</h3>
        <ul>
          <li>с 02.10.17 по 25.04.18</li>
          <li>
            250  ак. часов, в том числе
            <ul>
              <li>6 учебных экскурсий (1 пешеходная, 5 автобусных)</li>
              <li>1 зачетная экскурсия</li>
              <li>самостоятельная работа с дополнительным методическим материалом</li>
            </ul>
          </li>
        </ul>
        <h3>Занятия</h3>
        <ul>
          <li>понедельник, среда с 18:30 до 21:30</li>
          <li>пешеходные, учебные и зачетные экскурсии по выходным</li>
        </ul>
        <h3>Стоимость</h3>
        <ul>
          <li>за весь курс – 45 000 руб.; при единовременной оплате скидка 5% –  42 750  руб</li>
          <li>оплата помесячно:</li>
        </ul>
        <b-table
          responsive
          bordered
          striped
          :fields="fields"
          :items="items"
        />
        <div class="enroll-btn">
          <router-link class="btn btn-success btn-md btn-block" :to="{name: 'OnlineEnrollment'}">Записаться</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advLvlCourseCost } from '@/data'

export default {
  data () {
    return {
      items: advLvlCourseCost,
      fields: {
        paymentPeriod: {
          class: 'centered align-middle',
          label: 'Сроки оплаты'
        },
        month: {
          class: 'centered align-middle',
          label: 'За месяц'
        },
        paymentMonth: {
          class: 'centered align-middle',
          label: 'Сумма в рублях <br> за месяц'
        }
      }
    }
  }
}
</script>

<style media="screen">
  .enroll-btn {
    max-width: 200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// CoursesAdvanced.vue?2ae66642